import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { config } from '../config/config';

const Locations = () => {
  const [activeLocation, setActiveLocation] = useState('Gurugram');

  const locations = [
    'Gurugram',
    'Delhi'
  ];

  return (
    <section className="locations" id="locations">
      <motion.div
        className="loc-title"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        WE SERVE ACROSS {config.business.serviceAreas.join(' & ').toUpperCase()}
      </motion.div>
      <motion.div
        className="loc-pills"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        {locations.map((loc, idx) => (
          <motion.div
            key={idx}
            className={`loc-pill ${activeLocation === loc ? 'active' : ''}`}
            onClick={() => setActiveLocation(loc)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {loc}
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default Locations;
